import { ApiRequest } from "src/models/api.request";
import api from "../core/api";
import { helper } from "src/utils/helper";
import VwHbsIslemtanimDTO from "src/models/GenelTanimlar/VwHbsIslemtanimDTO";
import VwHbsGenetikkodListeDTO from "src/models/GenelTanimlar/VwHbsGenetikkodListeDTO";
import VwHbsIslemtanimGenkodlisteDTO from "src/models/GenelTanimlar/VwHbsIslemtanimGenkodlisteDTO";
import HbsIslemtanimDTO from "src/models/GenelTanimlar/hbsislemtanimDTO";
import VwIslemaramaAutocompleteDTO from "src/models/PatolojiModul/VwIslemaramaAutocompleteDTO";
import { GridPaginationModel } from "@mui/x-data-grid-premium";
import { ApiResponse } from "../core";


const controllerName = "VwHbsIslemtanimDTO/";
const controllerNameCrud = "HbsIslemtanimDTO/";
const controllerName2 = "VwHbsGenetikkodListeDTO/";
const controllerName3 = "VwHbsIslemtanimGenkodlisteDTO/";
const controllerName5 = "VwIslemaramaAutocompleteDTO/";

export const IslemApi = api.injectEndpoints({
    endpoints: (builder) => ({
        getHbsIslemtanim: builder.query<Array<VwHbsIslemtanimDTO>, { id?: Array<number>, raporTipModul?: number, searchText?: string }>({
            query: (request) => {
                let req: ApiRequest<VwHbsIslemtanimDTO> = {
                    filters: {
                        groupOperator: 'and',
                        predicates: [
                            {
                                fieldName: 'aktif',
                                operator: '=',
                                value1: 'E'
                            }
                        ]
                    },
                    sorts: [{ fieldName: 'id', ascending: false }]
                }
                if (request?.raporTipModul === 2)
                    req.filters.predicates.push({
                        fieldName: "islemtanimtipId",
                        operator: "=",
                        value1: 1
                    });
                if (request?.searchText?.length > 0)
                    req.filters.predicates.push({
                        fieldName: "searchText",
                        operator: "like",
                        value1: request.searchText
                    });
                // #TODO: 1000 Kayıttan sonra oracle hata veriyor.
                if (request.id?.length > 0) {
                    var uzunluk = 0;
                    var al = [];
                    var fark = 0;
                    for (var i = 0; i < request.id.length; i++) {
                        if (uzunluk <= i) {
                            if (uzunluk < 1000) {
                                al.push(request.id[i]);
                                uzunluk++;
                                fark++;
                            }
                            if (uzunluk === 1000) {
                                req.filters.predicates.push({
                                    fieldName: 'id',
                                    operator: 'in',
                                    not: true,
                                    value1: al
                                });
                                uzunluk = 0;
                                al = [];
                            }
                            if (Number(fark) === request.id.length) {
                                req.filters.predicates.push({
                                    fieldName: 'id',
                                    operator: 'in',
                                    not: true,
                                    value1: al
                                });
                                uzunluk = 0;
                                fark = 0;
                                al = [];
                            }
                        }
                    }
                }
                return {
                    url: controllerName + "find",
                    method: "POST",
                    body: JSON.stringify(req)
                }
            },
            providesTags: ["Islemtanim"]
        }),
        getIslemTanim: builder.query<Array<VwHbsIslemtanimDTO>, void>({
            query: () => ({
                url: controllerName + "find",
                method: "POST",
                body: JSON.stringify({})
            })
        }),
        IslemTanimFind: builder.query<ApiResponse<Array<VwHbsIslemtanimDTO>>, void>({
            query: (request) => {
                return {
                    url: controllerName + "find",
                    method: "POST",
                    body: JSON.stringify({}),
                }
            },
            providesTags: ["Islemtanim"]
        }),
        IslemTanimAdd: builder.mutation<HbsIslemtanimDTO, HbsIslemtanimDTO>({
            query: (request) => ({
                url: controllerNameCrud,
                method: "POST",
                body: JSON.stringify(request)
            }),
            invalidatesTags: ["Islemtanim"]
        }),
        IslemTanimUpdate: builder.mutation<HbsIslemtanimDTO, HbsIslemtanimDTO>({
            query: (request) => ({
                url: controllerNameCrud,
                method: "PUT",
                body: JSON.stringify(request)
            }),
            invalidatesTags: ["Islemtanim"]
        }),
        IslemTanimDelete: builder.mutation<boolean, number>({
            query: (id) => ({
                url: controllerName + `${id}`,
                method: "DELETE"
            }),
            invalidatesTags: ["Islemtanim"]
        }),
        GenetikKodFind: builder.query<Array<VwHbsGenetikkodListeDTO>, void>({
            query: (request) => {
                var req: ApiRequest<VwHbsGenetikkodListeDTO> = {
                    paging: false,
                    pageIndex: 0,
                    pageSize: 0,
                    filters: helper.convertApiFilters(null),
                    sorts: helper.convertApiSorts([], {
                        fieldName: 'id',
                        ascending: false
                    })
                }
                return {
                    url: controllerName2 + "find",
                    method: "POST",
                    body: req
                }
            },
            providesTags: ["Islemtanim"]
        }),
        IslemTanimBagliGenKodlar: builder.query<Array<VwHbsIslemtanimGenkodlisteDTO>, { id?: number }>({
            query: (request) => {
                var req: ApiRequest<VwHbsIslemtanimGenkodlisteDTO> = {
                    paging: false,
                    pageIndex: 0,
                    pageSize: 0,
                    filters: {
                        groupOperator: "and",
                        predicates: []
                    }
                }
                if (request.id > 0) {
                    req.filters.predicates.push({
                        fieldName: "id",
                        operator: "=",
                        value1: request.id
                    });
                }
                return {
                    url: controllerName3 + "find",
                    method: "POST",
                    body: req,
                    cache: "no-cache",
                }
            },
            keepUnusedDataFor: 0
        }),
        getIslemTanimAutoComplete: builder.query<Array<VwIslemaramaAutocompleteDTO>, { id?: Array<number>, raporTipModul?: number, searchText?: string, organizasyonId: number }>({
            query: (request) => {
                let req: ApiRequest<VwIslemaramaAutocompleteDTO> = {
                    filters: {
                        groupOperator: 'and',
                        predicates: [
                            {
                                fieldName: 'aktif',
                                operator: '=',
                                value1: 'E'
                            }
                        ]
                    },
                    sorts: [{ fieldName: 'id', ascending: false }]
                }
                if (request?.raporTipModul === 2)
                    req.filters.predicates.push({
                        fieldName: "islemtanimtipId",
                        operator: "=",
                        value1: 1
                    });
                if (request?.searchText?.length > 0)
                    req.filters.predicates.push({
                        fieldName: "searchText",
                        operator: "like",
                        value1: request.searchText
                    });
                // #TODO: 1000 Kayıttan sonra oracle hata veriyor.
                if (request.id?.length > 0) {
                    var uzunluk = 0;
                    var al = [];
                    var fark = 0;
                    for (var i = 0; i < request.id.length; i++) {
                        if (uzunluk <= i) {
                            if (uzunluk < 1000) {
                                al.push(request.id[i]);
                                uzunluk++;
                                fark++;
                            }
                            if (uzunluk === 1000) {
                                req.filters.predicates.push({
                                    fieldName: 'id',
                                    operator: 'in',
                                    not: true,
                                    value1: al
                                });
                                uzunluk = 0;
                                al = [];
                            }
                            if (Number(fark) === request.id.length) {
                                req.filters.predicates.push({
                                    fieldName: 'id',
                                    operator: 'in',
                                    not: true,
                                    value1: al
                                });
                                uzunluk = 0;
                                fark = 0;
                                al = [];
                            }
                        }
                    }
                }
                return {
                    url: controllerName5 + "find",
                    method: "POST",
                    body: JSON.stringify(req)
                }
            },
            keepUnusedDataFor: 0
        }),
        getVwHbsIslemtanimById: builder.query<VwHbsIslemtanimDTO, number>({
            query: (id) => ({
                url: controllerName + id,
                method: "GET"
            })
        }),
    })
});

export const {
    useGetHbsIslemtanimQuery,
    useLazyGetHbsIslemtanimQuery,
    useGetIslemTanimQuery,

    useIslemTanimFindQuery,
    useIslemTanimAddMutation,
    useIslemTanimUpdateMutation,
    useIslemTanimDeleteMutation,

    useGenetikKodFindQuery,
    useIslemTanimBagliGenKodlarQuery,
    useLazyGetIslemTanimAutoCompleteQuery,
    useGetIslemTanimAutoCompleteQuery,
    useGetVwHbsIslemtanimByIdQuery
} = IslemApi